<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">合同数据</span>
      </div>
      <div class="query_box"></div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="count_card">
          <div>
            <CountUp :end="contract_dict.entry_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title">当前在职</div>
        </div>
        <div class="count_card3" @click="click_count('已签署', this.contract_dict.entry_sign_list, [])">
          <div>
            <CountUp :end="contract_dict.entry_sign_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">已签署</div>
        </div>
        <div class="count_card3"
          @click="click_count('未签署', this.contract_dict.entry_untreated_list, this.contract_dict.weiqian_audit_id_list)">
          <div>
            <CountUp :end="contract_dict.entry_untreated_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">未签署</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp :decimals="2" :end="contract_dict.entry_sign_ratio" :duration="4" v-font="18" />
            <span class="ratiospan">%</span>
          </div>
          <div class="count_title">签署率</div>
        </div>
        <div class="count_card3" @click="click_project_contract_list()">
          <div>
            <CountUp :end="contract_dict.entry_sign_count" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">批量下载合同</div>
        </div>
      </div>
    </div>

    <Drawer :title="drawer_title" :closable="false" v-model="show" width="85">
      <div>
        <Alert v-if="drawer_title == '未签署-详情'" type="success">说明:未签署过合同的员工与合同到期的员工,纸质上传与电子签发起时会统计签署次数,<span @click="rushsign_batch" class="rushsign_batch_span"><Icon type="ios-mail" />点击批量催签</span></Alert>
        <Alert v-if="drawer_title == '已签署-详情'" type="success">说明:在本项目签署过合同</Alert>
      </div>
      <div>
        <Spin fix v-if="table_loading"></Spin>
        <Table size="small" ref="table" :height="windowHeight - 155" :columns="columns" :data="table_data">
          
          <template #contract_start_end="{ row }">
            <div>
              <span @click="view_contract_info(row)" class="contract_start_end">{{ row.contract_start_end }}次</span>
            </div>
          </template>
        </Table>
      </div>
      <div class="export_div" @click="export_table">
        <Icon type="md-download" />导出表格
      </div>
    </Drawer>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "contract_data",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      project_id: "",
      project_name: "",
      query_date: [],
      contract_dict: {
        entry_count: 0,
        entry_sign_count: 0,
        entry_sign_ratio: "",
        entry_untreated_count: 0,
      },

      show: false,
      table_loading:false,
      columns: [],
      table_data: [],
      drawer_title: "",
      weiqian_audit_id_list: [],

      loading: false,
    };
  },

  methods() { },
  methods: {
    //合同列表
    click_project_contract_list() {
      console.log("合同列表");
      // this.$router.push({
      //     path:'/roster_manage/contract',
      //     query:{
      //         project_id:this.project_id,
      //     }
      // })
      open_new_page(
        "/roster_manage/contract?project_id=" +
        this.project_id +
        "&entry_status=0",
        "_blank"
      );
    },
    click_count(title, data_list, weiqian_audit_id_list) {
      console.log(data_list);
      this.drawer_title = title + "-详情";
      this.show = true;

      this.columns = [
        {
          title: "序号",
          key: "index",
          width: 60,
        },
        {
          title: "姓名",
          key: "name",
          width: 120,
        },
        {
          title: "签署次数",
          key: "contract_start_end",
          slot: "contract_start_end",
          width: 100,
          sortable: true
        },
        {
          title: "身份证号",
          key: "idcard",
          width: 180,
        },
        {
          title: "手机号",
          key: "phone",
          width: 140,
        },
        {
          title: "年龄",
          key: "age",
          width: 60,
        },
        {
          title: "入职时间",
          key: "entry_time",
          minWidth: 140,
          sortable: true
        },
        {
          title: "最近合同到期时间",
          key: "lately_time_fmt",
          minWidth: 140,
          sortable: true
        },
      ];
      this.table_data = data_list;
      this.weiqian_audit_id_list = weiqian_audit_id_list
    },

    view_contract_info(row) {
      var url =
        "https://contract.daxiangsys.com/contract_manage/search/detail?idcard=" +
        row.idcard;
      open_new_page(url);
    },

    date_picker_change(e) {
      console.log(e);
      this.get_interview_data();
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_contract_data();
    },
    //批量催签
    rushsign_batch() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        audit_id_list: this.weiqian_audit_id_list
      };
      this.table_loading = true
    
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/contract/rushsign_batch",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.table_loading = false
        });
    },
    //合同数据
    get_contract_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/contract/info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.contract_dict = res.data.contract_dict;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    export_table() {
      this.$refs.table.exportCsv({
        filename: "签署列表",
      });
    },
  },
};
</script>

<style scoped>
.rushsign_batch_span{
  cursor: pointer;
  color: #0466dd;
  font-weight: 600;
}

.contract_start_end {
  cursor: pointer;
  color: #0466dd;
}

.contract_start_end:hover {
  color: #003f8d;
  font-weight: 600;
}

.export_div {
  padding-top: 5px;
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: flex-end;
  cursor: pointer;
  color: #0466dd;
}

.ratiospan {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 8px;
}

.title_text2 {
  font-weight: 600;
}

.count_card3:hover {
  background: #0466dd;
  color: #fff;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.count_title3 {
  font-size: 13px;
  margin-top: 5px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_card {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 120px;
  border-radius: 5px;
  border: 1px solid #ececec;
  background-color: #fff;
  text-align: center;
}

.count_card2 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(89, 146, 220);
  text-align: center;
}

.count_card3 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 120px;
  border: 1px solid #b8bef7;
  border-radius: 5px;
  background-color: rgb(255, 255, 255);
  text-align: center;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
